import * as Sentry from "@sentry/react";

const callAPI = async <RequestDataType, ResponseDataType>(
  url: string | undefined,
  formValues: RequestDataType
): Promise<{ data?: ResponseDataType; errorType?: "client" | "server" | "invalidEmail" }> => {
  if (!url) {
    Sentry.captureException("endpoint not defined")
    return { errorType: "server" }
  }

  try {
    const response = await window.fetch(url, {
      method: "POST",
      body: JSON.stringify(formValues),
    })

    // success
    if (response.ok) {
      const data = await response.json()
      return { data }
    }
    // client side error
    if (response.status === 422) {
      const errorData = await response.json()
      if (errorData?.error_key === "invalid_email") {
        return { errorType: "invalidEmail" }
      }
      return { errorType: "client" }
    }
    // other errors not defined on server
    return { errorType: "server" }
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      // ensure something gets logged on dev, where Sentry is not enabled
      console.error(error)
    }
    // network errors
    Sentry.captureException(error, {
      extra: { form_data: JSON.stringify(formValues) },
    })
    return { errorType: "server" }
  }
}

export { callAPI };

